"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRowItems = exports.getGroupRows = exports.getGroups = exports.getState = void 0;

var _reduxOrm = require("redux-orm");

var _orm = _interopRequireDefault(require("./orm"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var getState = function getState(store) {
  return store.ChiaraBannersBuilderComponent;
};

exports.getState = getState;
var getGroups = (0, _reduxOrm.createSelector)(_orm["default"].Group);
exports.getGroups = getGroups;
var getGroupRows = (0, _reduxOrm.createSelector)(_orm["default"].Group.rows);
exports.getGroupRows = getGroupRows;
var getRowItems = (0, _reduxOrm.createSelector)(_orm["default"].Row.items);
exports.getRowItems = getRowItems;